import {
  fetchTranslationFail,
  fetchTranslationRequest,
  fetchTranslationSuccess
} from '../store/ActionReducers/translation.actionreducer';

import {Dispatch} from 'redux';
import {httpbase} from '../utils/axios.utils';

export const fetchTranslation = ()=>{
  return async(dispatch:Dispatch)=>{
    dispatch(fetchTranslationRequest());
    try{
      const response = await httpbase().get(`translations`);
      dispatch(fetchTranslationSuccess(response.data.data));
    }catch(e:any){
      if(e && e.response && e.response.data){
        dispatch(fetchTranslationFail(e.response.data));
      }
      dispatch(fetchTranslationFail("Something went wrong!"));
    }
  }
}